export class ClientError extends Error {
  constructor(code, message) {
      super(message);
      this.code = code;
  }

  get name() {
      return this.constructor.name;
  }
  
  static NOT_LOGGED_IN = "NOT_LOGGED_IN";
  static INVALID_DATA_FORMAT = "INVALID_DATA_FORMAT";
  static NO_PERMISSION = "NO_PERMISSION";
  static TOO_MANY_ITEMS = "TOO_MANY_ITEMS";
}
